import React, {useState} from 'react';
import {toast, setOptions, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {loadStripe} from '@stripe/stripe-js';
import {Elements, CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
import '../styles/utilsCardToken.css';
import Decode from "./Decode";
import English from '../locale/english.json';
import Spanish from '../locale/spanish.json';

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

const CardToken = ({textNext, Next, textBack, Back, setStripe}) => {
    const stripePromise = loadStripe(Decode('cGtfbGl2ZV9oWGNyR0FCM0RsMGRvUFo5TmFiTzlVSUg='));
    const [locale, setLocale] = useState((window.localStorage.locale && window.localStorage.locale === 'es') ? Spanish : English);
    const [elementOptions, setElementOptions] = useState({appearance: {theme: 'stripe'}});
    const [cardOptions, setCardOptions] = useState({
        hidePostalCode: true,
        style: {
            base: {
                color: '#333',
                fontFamily: 'Arial, sans-serif',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4',
                },
                padding: '10px 0'
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            },
        }
    });
    const CheckoutForm = () => {
        const stripe = useStripe();
        const elements = useElements();
        const [saving, setSaving] = useState(false);

        const ButtonBack = async () => {
            Back();
        }
        const ButtonNext = async () => {
            setSaving(true);

            const cardElement = elements.getElement(CardElement);

            const {error, paymentMethod} = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });

            if (error) {
                toast({message: error.message, color: 'danger', display: 'bottom', duration: 3000});
                setSaving(false);
            } else if (paymentMethod) {
                setSaving(false);
                const item = {
                    brand: (paymentMethod.card && paymentMethod.card.brand) ? paymentMethod.card.brand : null,
                    last4: (paymentMethod.card && paymentMethod.card.last4) ? paymentMethod.card.last4 : null,
                    country: (paymentMethod.card && paymentMethod.card.country) ? paymentMethod.card.country : null,
                    method: paymentMethod.id
                }
                setStripe(item);
                Next(item);
            }
        };

        return (
            <>
                <div className="cs-utils-card-token-card">
                    <CardElement options={cardOptions} />
                </div>
                <div className="cs-utils-card-token-helper">
                    <p>
                        {locale.cardToken.a}
                    </p>
                </div>
                <div className="mbsc-button-group-justified cs-utils-card-token-nav-buttons">
                    {Back &&
                        <Button disabled={saving} color="primary" variant="flat" className="mbsc-bold cs-utils-card-token-nav-button" onClick={() => ButtonBack()} >
                            {textBack}
                        </Button>
                    }
                    {Next &&
                        <Button disabled={!stripe || saving} color="primary" variant="flat" className="mbsc-bold cs-utils-card-token-nav-button" onClick={() => ButtonNext()} >
                            {textNext}
                        </Button>
                    }
                </div>
            </>
        );
    }

    return (
        <Elements stripe={stripePromise} options={elementOptions} >
            <CheckoutForm />
        </Elements>
    );
};

export default CardToken;
